import styled from 'styled-components';

export const Span = styled.span`
  display: flex;
`;
